"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var __jsx = _react.default.createElement;
var GatedContentEditConfig = {
  emptyLabel: 'Gated Content',
  isEmpty: function isEmpty(props) {
    if (typeof props.unAuthorizedLabel !== 'undefined' && props.unAuthorizedLabel) {
      return false;
    } else {
      return true;
    }
  }
};
var GatedContent = function GatedContent(_ref) {
  var unAuthorizedLabel = _ref.unAuthorizedLabel,
    unAuthorizedContentType = _ref.unAuthorizedContentType,
    gatedContentUrl = _ref.gatedContentUrl,
    gatedComponentType = _ref.gatedComponentType;
  return __jsx("div", null, __jsx("div", null, ' ', gatedComponentType && __jsx("p", null, " Gated Component Type : ", gatedComponentType, " "), ' '), __jsx("div", null, ' ', unAuthorizedContentType && __jsx("p", null, " Gated Content type : ", unAuthorizedContentType, " "), ' '), __jsx("div", null, ' ', unAuthorizedLabel && __jsx("p", null, " Gated Content Label : ", unAuthorizedLabel), ' '), __jsx("div", null, ' ', gatedContentUrl && __jsx("p", null, " Gated Content Page URL : ", gatedContentUrl, " "), ' '));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/gatedcontent')(GatedContent, GatedContentEditConfig);
exports.default = _default;